<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content>
  <div class="repeat-item-dialog-fields">
    <formly-form
      [form]="form"
      [fields]="data.fields"
      [model]="data.model"
      [options]="options"
    ></formly-form>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="repeat-item-dialog-actions">
  <button matButton type="button" (click)="onCancel()">Abbrechen</button>
  <button matButton type="button" (click)="onOk()">OK</button>
</mat-dialog-actions>
